import { render, staticRenderFns } from "./dictaLM.vue?vue&type=template&id=f17178a8&scoped=true"
import script from "./dictaLM.vue?vue&type=script&lang=js"
export * from "./dictaLM.vue?vue&type=script&lang=js"
import style0 from "./dictaLM.vue?vue&type=style&index=0&id=f17178a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17178a8",
  null
  
)

export default component.exports